import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import QuoteForm from './QuoteForm';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-slate-50 scroll-mt-28">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wider mb-3 block">
            Contactez-nous
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Demandez votre devis gratuit
          </h2>
          <p className="text-xl text-slate-600">
            Décrivez votre projet de rénovation et joignez vos plans ou photos.
            Nous revenons vers vous rapidement avec une étude adaptée.
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-3 gap-8">
            {/* Contact Info Cards */}
            <div className="space-y-6">
              <Card className="border-slate-200 hover:border-emerald-500 transition-all duration-300 hover:shadow-lg bg-white">
                <CardContent className="pt-6">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center flex-shrink-0">
                      <Phone className="h-6 w-6 text-emerald-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-slate-900 mb-1">Téléphone</h3>
                      <a href="tel:+33185097125" className="text-emerald-600 hover:text-emerald-700 font-medium">
                        01 85 09 71 25
                      </a>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-slate-200 hover:border-emerald-500 transition-all duration-300 hover:shadow-lg bg-white">
                <CardContent className="pt-6">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center flex-shrink-0">
                      <Mail className="h-6 w-6 text-emerald-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-slate-900 mb-1">Email</h3>
                      <a href="mailto:devis@vireo-renovation.fr" className="text-emerald-600 hover:text-emerald-700 font-medium break-all">
                        devis@vireo-renovation.fr
                      </a>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="border-slate-200 hover:border-emerald-500 transition-all duration-300 hover:shadow-lg bg-white">
                <CardContent className="pt-6">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center flex-shrink-0">
                      <MapPin className="h-6 w-6 text-emerald-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-slate-900 mb-1">Adresse</h3>
                      <p className="text-slate-600">
                        29 rue Tronchet<br />
                        75008 Paris
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-gradient-to-br from-emerald-600 to-emerald-700 border-none">
                <CardContent className="pt-6">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-white/15 rounded-xl flex items-center justify-center flex-shrink-0">
                      <Clock className="h-6 w-6 text-white" />
                    </div>
                    <div>
                      <p className="text-white font-semibold mb-1">Réponse rapide</p>
                      <p className="text-white/85 text-sm">
                        Nous revenons vers vous rapidement après réception de votre demande.
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-2">
              <Card className="border-slate-200 shadow-xl bg-white">
                <CardHeader>
                  <CardTitle className="text-2xl text-slate-900">Demander un devis gratuit</CardTitle>
                  <p className="text-slate-600">
                    Renseignez votre projet et joignez vos documents (plans, photos, devis…).
                  </p>
                </CardHeader>
                <CardContent>
                  <QuoteForm variant="standard" />
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
